import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { HolidayService } from '../proxy/general/controllers/holiday.service';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('General');

export const HOLIDAYDATE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .date('date', 'Entity.HolidayDate.Date')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'holidayId',
    'Entity.Holiday',
    HolidayService
  )
    .required()
    .displayFromNested('holiday.name')
    .sortBy('holiday.name')
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
];

export const HOLIDAYDATE_CONFIG = {
  entityName: 'HolidayDate',
  localizationKey: 'General::Entity.HolidayDate',
  fields: HOLIDAYDATE_FIELDS,
  permission: 'ControllingCalendar.HolidayDates',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
